import {
  TopBar,
  type TopBarProps,
} from '@cointracker/styleguide/src/TopBar/TopBar';
import { analytics } from '../../../common';

export const LandingTopBarWrapper = (props: TopBarProps) => {
  return <TopBar analytics={analytics} {...props} />;
};
